<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Entry & Loading Control
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/entry/daily-transaction"
                        >Entry</router-link
                      >
                    </li>
                    <li class="breadcrumb-item">Gate Control</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <div
            class="modal fade text-left"
            id="imagemodal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel16"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title" id="myModalLabel16">Crop Image</h4>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="container">
                    <cropper
                      ref="cropper"
                      :src="img"
                      :canvas="{
                        minHeight: 0,
                        minWidth: 0,
                        maxHeight: 2048,
                        maxWidth: 2048,
                      }"
                    />
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="crop('license')"
                  >
                    Crop
                  </button>
                </div>
              </div>
            </div>
          </div>
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div
                class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock"
              >
                <div class="w-auto px-0 mobile-padding-0-2">
                  <div
                    class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                  >
                    <div class="avatar-content">
                      <em class="las la-door-open i_icon_st font-medium-5"></em>
                    </div>
                  </div>

                  <h4 class="card-title d-inline-flex ml-0 mb-0">
                    Gate Control
                  </h4>
                </div>
                <div class="custom-control custom-switch custom-switch-primary">
                  <span class="font14_42"> Flash ON</span>
                  <span class="inoutmargin-5">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch14"
                      v-model="torch"
                      checked
                    />
                    <label class="custom-control-label" for="customSwitch14">
                      <span class="switch-icon-left"
                        ><i data-feather="check"></i
                      ></span>
                      <span class="switch-icon-right"
                        ><i data-feather="x"></i
                      ></span>
                    </label>
                  </span>
                  <span class="font14_74"> OFF</span>
                </div>

                <div
                  class="col-12 col-sm-6 col-md-6 col-lg-4 mb-0 mobileview_b_8 mobileview_b_px00"
                >
                  <!-- <label class="form-label">Select Camera<span class="requiredField">*</span></label> -->
                  <treeselect
                    placeholder="Select Camera"
                    v-model="camera"
                    :options="camera_options"
                    @input="handleCameraSelection"
                  />
                </div>
              </div>

              <div
                class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
              >
                <div
                  class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both px-0"
                >
                  <nav
                    class="nav-tabs-wrapper mx-0 w-100 gateentry_viewpage_mobile"
                  >
                    <ul
                      class="nav nav-pills nav-pill-primary pt-1 nav-tabs-items dragscroll"
                    >
                      <li class="nav-item tabs-item">
                        <a
                          class="nav-link active"
                          id="gate_control_pass_tab"
                          data-toggle="tab"
                          href="#gate_control_pass"
                          aria-expanded="true"
                          >Gate Entry Pass</a
                        >
                      </li>
                      <li
                        class="nav-item tabs-item"
                        @click="getGateExitVehicles()"
                      >
                        <a
                          class="nav-link"
                          id="gate_exist_pass_tab"
                          data-toggle="tab"
                          href="#gate_exist_pass"
                          aria-expanded="false"
                        >
                          Gate Exit Pass
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="tab-content">
                  <div
                    role="tabpanel"
                    class="tab-pane active"
                    id="gate_control_pass"
                    aria-labelledby="gate_control_pass_tab"
                    aria-expanded="true"
                  >
                    <div class="row mx-0 contains entry_loading_control_container">
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <label class="form-label"
                          >Gate No<span class="requiredField">*</span></label
                        >
                        <treeselect
                          placeholder="Select Gate No"
                          v-model="formData.gate_number"
                          :options="gateNumberList"
                        />
                        <!-- <div class="errorinputmsg" v-if="!formData.gate_number">
                                        Required field
                                    </div> -->
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <label class="form-label">
                          Vehicle No <span class="requiredField">*</span></label
                        >
                        <treeselect
                          v-if="!formData.is_marketing_vehicle"
                          placeholder="Select Vehicle No"
                          v-model="formData.vehicle_number"
                          :options="vehicleNumberList"
                          @input="handleVehicleChange"
                        />
                        <input
                          v-else
                          class="form-control"
                          v-model="formData.vehicle_number2"
                          type="text"
                          placeholder="Enter Market Vehicle Number "
                        />
                        <!-- <div class="errorinputmsg" v-if="!formData.vehicle_number">
                                        Required field
                                    </div> -->
                        <label for="is_marketing_vehicle"
                          >Is Market Vehicle</label
                        >
                        <input
                          class="mt-1 ml-1"
                          type="checkbox"
                          id="is_marketing_vehicle"
                          v-model="formData.is_marketing_vehicle"
                        />
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                        v-if="!formData.is_marketing_vehicle"
                      >
                        <label class="form-label">Route Path (Route No.)</label>
                        <treeselect
                          placeholder="Select Route Path"
                          v-model="formData.route_number"
                          :options="routeNumerList"
                        />
                        <!-- <div class="errorinputmsg" v-if="!formData.gate_number">
                                        Required field
                                    </div> -->
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <label for="should_vehicle_be_parked"
                          >Without Seal</label
                        >
                        <input
                          class="mt-1 ml-1"
                          type="checkbox"
                          id="should_vehicle_be_parked"
                          v-model="is_seal_optional"
                          @change="handleSealOptionChange"
                        />
                      </div>
                      <div
                        v-if="!is_seal_optional"
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <label class="form-label">
                          Total Number of seals
                          <span class="requiredField">*</span></label
                        >
                        <treeselect
                          :clearable="false"
                          clear="false"
                          placeholder="Select Number of Seals"
                          v-model="sealNumberCount"
                          :options="sealNumberList"
                        />
                      </div>
                      <div
                        v-if="!is_seal_optional"
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <template
                          v-for="(data, index) in Array(sealNumberCount).fill(
                            0
                          )"
                        >
                          <label class="form-label"
                            >Seal Photo {{ index + 1 }}</label
                          >
                          <div
                            class="col-sm-12 px-0 plate_photoscan_mobile_canvasimage"
                          >
                            <img
                              alt=""
                              class="round img-fluid"
                              src="../../public/images/icons/Img_box_duotone_line.svg"
                            />
                            <canvas
                              :id="'seal' + index + '-canvas'"
                              class="c"
                              width="350"
                              height="350"
                            ></canvas>
                          </div>
                          <div class="col-sm-12 px-0 plate_photoscan_mobile">
                            <video
                              :id="'seal' + index + '-video'"
                              class="overlay-camera"
                              autoplay
                              @click="capturePhoto('seal', index)"
                            ></video>
                          </div>
                          <div
                            class="col-12 col-sm-12 px-0 plate_photoscan_mobile mt-1 plate_photoscan_mobile_full100"
                          >
                            <div class="row mx-0 mt-1">
                              <div class="col-10 col-sm-10 px-0">
                                <div class="form-group">
                                  <input
                                    v-if="index === 0"
                                    class="form-control"
                                    type="text"
                                    v-model="captures.seal.seal_number_0"
                                    placeholder="Enter Seal No"
                                  />
                                  <input
                                    v-if="index === 1"
                                    class="form-control"
                                    type="text"
                                    v-model="captures.seal.seal_number_1"
                                    placeholder="Enter Seal No"
                                  />
                                  <input
                                    v-if="index === 2"
                                    class="form-control"
                                    type="text"
                                    v-model="captures.seal.seal_number_2"
                                    placeholder="Enter Seal No"
                                  />
                                  <input
                                    v-if="index === 3"
                                    class="form-control"
                                    type="text"
                                    v-model="captures.seal.seal_number_3"
                                    placeholder="Enter Seal No"
                                  />
                                  <div
                                    class="errorinputmsg"
                                    v-if="
                                      index === 0 &&
                                      !captures.seal.seal_number_0
                                    "
                                  >
                                    Required field
                                  </div>
                                  <div
                                    class="errorinputmsg"
                                    v-else-if="
                                      index === 1 &&
                                      !captures.seal.seal_number_1
                                    "
                                  >
                                    Required field
                                  </div>
                                  <div
                                    class="errorinputmsg"
                                    v-else-if="
                                      index === 2 &&
                                      !captures.seal.seal_number_2
                                    "
                                  >
                                    Required field
                                  </div>
                                  <div
                                    class="errorinputmsg"
                                    v-else-if="
                                      index === 3 &&
                                      !captures.seal.seal_number_3
                                    "
                                  >
                                    Required field
                                  </div>
                                </div>
                              </div>
                              <div class="col-2 col-sm-2 px-0 text-right">
                                <button
                                  class="gateentyscan_camera_icon"
                                  @click="turnOnCamera('seal', index)"
                                >
                                  <em class="las la-camera feather-camera"></em>
                                </button>
                                <audio
                                  :id="'seal' + index + '-sound'"
                                  :src="photoCaptureSound"
                                ></audio>
                              </div>
                            </div>
                          </div>
                        </template>
                        <div
                          class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                        ></div>
                      </div>
                      <div
                        v-if="!is_seal_optional"
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                      >
                        <label for="is_seal_verified">Is Seal Verified?</label>
                        <input
                          class="mt-1 ml-1"
                          type="checkbox"
                          id="is_seal_verified"
                          v-model="formData.is_seal_verified"
                        />
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                      >
                        <label class="form-label"
                          >Vehicle/Plate Photo<span class="requiredField"
                            >*</span
                          ></label
                        >
                        <div
                          class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto"
                        >
                          <img
                            alt=""
                            class="round img-fluid"
                            src="../../public/images/icons/Img_box_duotone_line.svg"
                          />
                          <canvas
                            id="plate-canvas"
                            class="c"
                            width="350"
                            height="350"
                          ></canvas>
                        </div>
                        <div class="col-sm-6 plate_photoscan_mobile">
                          <video
                            id="plate-video"
                            class="overlay-camera"
                            autoplay
                            @click="capturePhoto('plate')"
                          ></video>
                        </div>
                        <div
                          class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0"
                        >
                          <!-- <span>
                                            <vue-element-loading :active="ocrInProgress" color="#FF6700"/>
                                            <b style="color: #69db7c">{{formData.ocr_vehicle_number}}</b></span> -->
                          <button
                            class="gateentyscan_camera_icon"
                            @click="turnOnCamera('plate')"
                          >
                            <em class="las la-camera feather-camera"></em>
                          </button>
                          <audio
                            id="plate-sound"
                            :src="photoCaptureSound"
                          ></audio>
                        </div>
                        <div>
                          <!-- <input type="file" @change="handleOcrFileChange" /> -->
                        </div>
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                      >
                        <label class="form-label">Aadhar Photo</label>
                        <cropper
                          class="cropper"
                          id="aadhar-canvas"
                          ref="aadhar-cropper"
                          :src="captures.aadhar.img"
                          :canvas="{
                            width: 350,
                            height: 350,
                          }"
                          v-if="captures.aadhar.showCropper"
                          :default-size="aadharDefaultSize"
                        />
                        <div
                          v-else
                          class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto"
                        >
                          <img
                            alt=""
                            class="round img-fluid"
                            src="../../public/images/icons/Img_box_duotone_line.svg"
                          />
                        </div>
                        <video
                          id="aadhar-video"
                          class="overlay-camera"
                          autoplay
                          @click="captureDocumentPhoto('aadhar')"
                        ></video>
                        <div
                          class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0"
                        >
                          <button
                            class="gateentyscan_camera_icon mr-1"
                            @click="turnOnCamera('aadhar')"
                          >
                            <em class="las la-camera feather-camera"></em>
                          </button>
                          <button
                            class="btn btn-secondary cropimagebutton01"
                            @click="cropImage('aadhar')"
                          >
                            Crop
                          </button>
                          <audio
                            id="aadhar-sound"
                            :src="photoCaptureSound"
                          ></audio>
                        </div>
                      </div>
                      <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5">
                                    <label class="form-label">License Photo<span class="requiredField">*</span></label>
                                    <div class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto">
                                        <img alt=""  class="round img-fluid" src="../../public/images/icons/camera4.png">
                                        <canvas id="license-canvas" class="c" width=350 height=350></canvas>
                                    </div>
                                    <div class="col-sm-6 plate_photoscan_mobile">
                                        <video id="license-video" class="overlay-camera" autoplay @click="capturePhoto('license')"></video>
                                    </div>
                                    <div class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0">
                                        <button class="gateentyscan_camera_icon"  @click="turnOnCamera('license')">
                                           <em class="las la-camera feather-camera"></em>
                                        </button>
                                        <audio id="license-sound" :src="photoCaptureSound"></audio>
                                    </div>
                                </div> -->
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                      >
                        <label class="form-label"
                          >License Photo<span class="requiredField"
                            >*</span
                          ></label
                        >
                        <cropper
                          class="cropper"
                          id="license-canvas"
                          ref="license-cropper"
                          :src="captures.license.img"
                          :canvas="{
                            width: 350,
                            height: 350,
                          }"
                          v-if="captures.license.showCropper"
                          :default-size="licenseDefaultSize"
                        />
                        <div
                          v-else
                          class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto"
                        >
                          <img
                            alt=""
                            class="round img-fluid"
                            src="../../public/images/icons/Img_box_duotone_line.svg"
                          />
                        </div>
                        <video
                          id="license-video"
                          class="overlay-camera"
                          autoplay
                          @click="captureDocumentPhoto('license')"
                        ></video>
                        <div
                          class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0"
                        >
                          <button
                            class="gateentyscan_camera_icon mr-1"
                            @click="turnOnCamera('license')"
                          >
                            <em class="las la-camera feather-camera"></em>
                          </button>
                          <button
                            class="btn btn-secondary cropimagebutton01"
                            @click="cropImage('license')"
                          >
                            Crop
                          </button>
                          <audio
                            id="license-sound"
                            :src="photoCaptureSound"
                          ></audio>
                        </div>
                      </div>

                      <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5">
                                    <label class="form-label">Document Photo<span class="requiredField">*</span></label>
                                    <div class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto">
                                        <img alt=""  class="round img-fluid" src="../../public/images/icons/camera4.png">
                                        <canvas id="document-canvas" class="c" width=350 height=350></canvas>
                                    </div>
                                    <div class="col-sm-6 plate_photoscan_mobile">
                                        <video id="document-video" class="overlay-camera" autoplay @click="capturePhoto('document')"></video>
                                    </div>
                                    <div class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0">
                                        <button class="gateentyscan_camera_icon"  @click="turnOnCamera('document')">
                                           <em class="las la-camera feather-camera"></em>
                                        </button>
                                        <audio id="document-sound" :src="photoCaptureSound"></audio>
                                    </div>
                                </div> -->
                      <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                    <label class="form-label">Document Confirmation</label>
                                    <div class="demo-inline-spacing" style="margin-top:5px;">
                                        <div class="form-check form-check-inline mt-0">
                                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" v-model="formData.document_confirmation" checked />
                                            <label class="form-check-label" for="inlineRadio1">YES</label>
                                        </div>
                                        <div class="form-check form-check-inline mt-0">
                                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="0" v-model="formData.document_confirmation" />
                                            <label class="form-check-label" for="inlineRadio2">No</label>
                                        </div>
                                    </div>
                                </div> -->
                      <div
                        class="pull-right text-right col-md-12 col-sm-12 col-xs-12 mb-2 common_trs_buttons_res"
                      >
                        <button
                          type="button"
                          class="btn btn-relief-primary common-btn_btn_view"
                          @click="saveData"
                          :disabled="!validateForm()"
                        >
                          Submit
                        </button>
                        <button
                          type="reset"
                          class="btn btn-relief-secondary common-btn_btn_view"
                          @click="resetform()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    class="tab-pane"
                    id="gate_exist_pass"
                    aria-labelledby="gate_exist_pass_tab"
                    aria-expanded="true"
                  >
                    <div class="row mx-0">
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <label class="form-label"
                          >Gate No<span class="requiredField">*</span></label
                        >
                        <treeselect
                          placeholder="Select Gate No"
                          v-model="formData_gate_exit.gate_number"
                          :options="exitGateList"
                        />
                        <!-- <div class="errorinputmsg" v-if="!formData.gate_number">
                                        Required field
                                    </div> -->
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8"
                      >
                        <label class="form-label">
                          Vehicle No <span class="requiredField">*</span></label
                        >
                        <treeselect
                          placeholder="Select Vehicle No"
                          v-model="formData_gate_exit.vehicle_number"
                          :options="exitVehicleNumberList"
                          @input="getVehicleEntryPass"
                        />
                        <!-- <div class="errorinputmsg" v-if="!formData.vehicle_number">
                                        Required field
                                    </div> -->
                      </div>
                      <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                                    <label class="form-label"> Total Number of seals <span class="requiredField">*</span></label>
                                    <treeselect :clearable="false" clear="false" placeholder="Select Vehicle No" v-model="sealExitNumberCount" :options="sealNumberList" />
                                </div> -->
                      <template
                        v-for="(data, index) in Array(sealExitNumberCount).fill(
                          0
                        )"
                      >
                        <div
                          class="col-12 col-sm-12 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                        >
                          <label class="form-label"
                            >Seal Photo {{ index + 1 }}</label
                          >
                          <div
                            class="col-sm-12 px-0 plate_photoscan_mobile_canvasimage"
                          >
                            <img
                              alt=""
                              class="round img-fluid"
                              src="../../public/images/icons/Img_box_duotone_line.svg"
                            />
                            <canvas
                              :id="'seal' + index + '-gate_exit_canvas'"
                              class="c"
                              width="350"
                              height="350"
                            ></canvas>
                          </div>
                          <div class="col-sm-12 px-0 plate_photoscan_mobile">
                            <video
                              :id="'seal' + index + '-gate_exit_video'"
                              class="overlay-camera"
                              autoplay
                              @click="captureGateExitPhoto('seal', index)"
                            ></video>
                          </div>
                          <div
                            class="col-12 col-sm-12 px-0 plate_photoscan_mobile mt-1 plate_photoscan_mobile_full100"
                          >
                            <div class="row mx-0">
                              <div class="col-10 col-sm-10 px-0">
                                <div class="form-group">
                                  <input
                                    v-if="index === 0"
                                    disabled
                                    class="form-control"
                                    type="text"
                                    v-model="
                                      captures_gate_exit.seal.seal_number_0
                                    "
                                    placeholder="Enter Seal No"
                                  />
                                  <input
                                    v-if="index === 1"
                                    disabled
                                    class="form-control"
                                    type="text"
                                    v-model="
                                      captures_gate_exit.seal.seal_number_1
                                    "
                                    placeholder="Enter Seal No"
                                  />
                                  <input
                                    v-if="index === 2"
                                    disabled
                                    class="form-control"
                                    type="text"
                                    v-model="
                                      captures_gate_exit.seal.seal_number_2
                                    "
                                    placeholder="Enter Seal No"
                                  />
                                  <input
                                    v-if="index === 3"
                                    disabled
                                    class="form-control"
                                    type="text"
                                    v-model="
                                      captures_gate_exit.seal.seal_number_3
                                    "
                                    placeholder="Enter Seal No"
                                  />
                                  <div
                                    class="errorinputmsg"
                                    v-if="
                                      index === 0 &&
                                      !captures_gate_exit.seal.seal_number_0
                                    "
                                  >
                                    Required field
                                  </div>
                                  <div
                                    class="errorinputmsg"
                                    v-else-if="
                                      index === 1 &&
                                      !captures_gate_exit.seal.seal_number_1
                                    "
                                  >
                                    Required field
                                  </div>
                                  <div
                                    class="errorinputmsg"
                                    v-else-if="
                                      index === 2 &&
                                      !captures_gate_exit.seal.seal_number_2
                                    "
                                  >
                                    Required field
                                  </div>
                                  <div
                                    class="errorinputmsg"
                                    v-else-if="
                                      index === 3 &&
                                      !captures_gate_exit.seal.seal_number_3
                                    "
                                  >
                                    Required field
                                  </div>
                                </div>
                              </div>
                              <div class="col-2 col-sm-2 px-0 text-right">
                                <button
                                  class="gateentyscan_camera_icon"
                                  @click="turnOnExitScanCamera('seal', index)"
                                >
                                  <em class="las la-camera feather-camera"></em>
                                </button>
                                <audio
                                  :id="'seal' + index + '-gate_exit_sound'"
                                  :src="photoCaptureSound"
                                ></audio>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-for="(data, index) in gate_entry_pass_photos">
                        <div
                          class="col-12 col-sm-12 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                        >
                          <label class="form-label">{{
                            convertSnakeCaseToWords(data.fileName)
                          }}</label>
                          <div class="border plate_photoexitpass">
                            <img :src="data.data" alt="data.fileKey" />
                          </div>
                        </div>
                      </template>
                      <div
                        class="pull-right text-right col-md-12 col-sm-12 col-xs-12 mb-2 common_trs_buttons_res"
                      >
                        <button
                          type="button"
                          class="btn btn-relief-primary common-btn_btn_view"
                          @click="saveExitGateData"
                          :disabled="!validateGateExitForm()"
                        >
                          Submit
                        </button>
                        <button
                          type="reset"
                          class="btn btn-relief-secondary common-btn_btn_view"
                          @click="resetGateExitform()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import common_methods from "../utils/common_methods";
import searchMasterNameList from "../utils/searchMasterNameList";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  name: "GateEntry",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    VueElementLoading,
    Cropper,
  },
  data() {
    return {
      img: "",
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
      un: "",
      torch: false,
      pagefeatures: [],
      cropAllowed: ["aadhar", "license"],
      width: 0,
      height: 0,
      statuslist: [],
      selectedFile: null,
      imageUrl: null,
      isLoading: false,
      photoCaptureSound: "sound/iphone-camera-capture-6448.wav",
      fileTitle: ["plate", "aadhar", "license"],
      gateNumberList: [],
      vehicleNumberList: [],
      exitGateList: [],
      exitVehicleNumberList: [],
      sealNumberCount: 1,
      sealExitNumberCount: 0,
      sealNumberList: [
        { id: 1, label: "One" },
        { id: 2, label: "Two" },
        { id: 3, label: "Three" },
        { id: 4, label: "Four" },
      ],
      vehiclesRouteNumerList: [],
      routeNumerList: [],
      videoPoster: "images/icons/camera4.png",
      camera_options: [],
      camera: null,
      gate_entry_pass_photos: [],
      is_seal_optional: false,
      formData: {
        gate_number: null,
        vehicle_number: null,
        route_number: null,
        aadhar_number: null,
        driving_license: null,
        receiver_details: null,
        document_confirmation: 1,
        staff_code: null,
        seal_details: [],
        is_marketing_vehicle: false,
        vehicle_number2: null,
        is_seal_verified: false,
        ocr_vehicle_number: null,
      },
      captures: {
        v: {
          stream: null,
          file: null,
        },
        plate: {
          stream: null,
          file: null,
        },
        seal: {
          stream: null,
          stream1: null,
          stream2: null,
          stream3: null,
          file: null,
          file0: null,
          file1: null,
          file2: null,
          file3: null,
          seal_number_0: null,
          seal_number_1: null,
          seal_number_2: null,
          seal_number_3: null,
        },
        vehicle: {
          stream: null,
          file: null,
        },
        aadhar: {
          stream: null,
          file: null,
          img: null,
          isCropped: false,
          showCropper: false,
        },
        license: {
          stream: null,
          file: null,
          img: null,
          isCropped: false,
          showCropper: false,
        },
        document: {
          stream: null,
          file: null,
        },
      },
      formData_gate_exit: {
        gate_number: null,
        vehicle_number: null,
      },
      captures_gate_exit: {
        seal: {
          stream: null,
          file0: null,
          file1: null,
          file2: null,
          file3: null,
          seal_number_0: null,
          seal_number_1: null,
          seal_number_2: null,
          seal_number_3: null,
        },
      },
      ocrInProgress: false,
    };
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    console.log("mounted")
    
  },
  created() {
    console.log("created")
    this.getCameraSelection();
    this.getEntryGateList();
    this.getVehicleNumberList();
    this.getExitGateList();
    this.getGateExitVehicles();
  },
  methods: {
    change({ coordinates, canvas }) {
      this.coordinates = coordinates;
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image, that can be used
      // as src for <img/> to preview result
      this.img = canvas.toDataURL("image/jpeg");
    },
    pasteImage(id) {
      let canvas = document.getElementById(`${id}-canvas`);
      this.img = canvas.toDataURL("image/jpeg", 0.7);
    },
    crop(id, index = "") {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image, that can be used
      // as src for <img/> to preview result
      this.img = canvas.toDataURL("image/jpeg");
      let myCanvas = document.querySelector(`#${id}-canvas`);
      var ctx = myCanvas.getContext("2d");
      var img = new Image();
      img.onload = function () {
        ctx.drawImage(img, 0, 0); // Or at whatever offset you like
      };
      img.src = this.img;
      // canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      const storeFile = (file) => {
        if (index !== "") {
          this.captures[id][`file${index}`] = file;
        } else {
          this.captures[id].file = file;
        }
      };
      document.getElementById(`${id}-canvas`).toBlob(function (blob) {
        storeFile(new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }));
      }, "image/jpeg");
    },
    handleOcrFileChange() {
      const file = event.target.files[0];
      if (file) {
        this.getVehcleNumberPlateOCR(file);
        // this.performOCR(file);
      }
    },
    // getVehcleNumberPlateOCR(file) {
    //     this.ocrInProgress = true
    //     var formData = new FormData();
    //     formData.append("images", file)
    //     axios({
    //         "content-type": "multipart/form-data",
    //         method: "POST",
    //         url: `/ocr/vehicle-number-plate`,
    //         data: formData,
    //     })
    //     .then(result => {
    //         this.ocrInProgress = true
    //         console.log(result)
    //     })
    //     .catch(e => {
    //         this.ocrInProgress = true
    //         this.displayError(e)
    //     })
    // },
    getVehcleNumberPlateOCR(file) {
      this.ocrInProgress = true;
      let host = "https://Intellivision.fcappservices.in";
      axios({
        method: "POST",
        url: `${host}/api/login`,
        data: {
          username: "test@firstcry.com",
          password: "R#p2Lq9w@zXu",
        },
      })
        .then((result) => {
          if (result.data.status === "success") {
            var formData = new FormData();
            formData.append("images", file);
            axios({
              "content-type": "multipart/form-data",
              method: "POST",
              url: `${host}/api/get-vehicle-content`,
              data: formData,
              headers: {
                Authorization: `Bearer ${result.data.data.token}`,
              },
            })
              .then((imgResult) => {
                this.ocrInProgress = false;
                if (
                  imgResult.data.status === "success" &&
                  imgResult.data.data.length
                ) {
                  this.formData.ocr_vehicle_number =
                    imgResult.data.data[0].vehicle_number;
                  let selectedVehicle = this.vehicleNumberList.find(
                    (v) => v.id == this.formData.vehicle_number
                  );
                  if (selectedVehicle) {
                    let searchVehicle =
                      selectedVehicle.label.replace(/\s/g, "").toUpperCase() ==
                      this.formData.ocr_vehicle_number
                        .replace(/\s/g, "")
                        .toUpperCase();
                    if (searchVehicle) {
                      let message = "Vehicle Number matched successfully!";
                      this.sweetAlertSnackbar(message, "success");
                    } else {
                      let message =
                        "Vehicle Number not matched with captured vehicle plate number";
                      this.sweetAlertSnackbar(message);
                    }
                  } else {
                    this.sweetAlertSnackbar(
                      "Please select vehicle number first to match with vehicle plate"
                    );
                  }
                } else {
                  let message =
                    "Error searching Vehicle Number. Make sure to take clear photo";
                  this.sweetAlertSnackbar(message);
                }
              })
              .catch((e) => {
                this.ocrInProgress = false;
                this.isLoading = false;
                let response = e ? e.response : e;
                let message =
                  "Error searching Vehicle Number. Make sure to take clear photo: ";
                if (
                  response?.data &&
                  (response.data.message || response.data.msg)
                )
                  message = `${response.data.message}`;
                this.sweetAlertSnackbar(message);
              });
          }
        })
        .catch((e) => {
          let response = e ? e.response : e;
          this.ocrInProgress = false;
          this.isLoading = false;
          let message =
            "Error searching Vehicle Number. Make sure to take clear photo: " +
            e;
          if (response?.data && (response.data.message || response.data.msg))
            message = `${response.data.message}`;
          this.sweetAlertSnackbar(message);
        });
    },
    cropImage(id2, index = "") {
      let id = id2 + index;
      let cropperRef = this.$refs[`${id2}-cropper`];
      if (!cropperRef) return;
      const { canvas } = cropperRef.getResult();
      this.captures[id2].img = canvas.toDataURL("image/jpeg");
      this.captures[id2].isCropped = true;

      canvas.toBlob((blob) => {
        this.storeFile(
          new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }),
          id,
          index
        );
      }, "image/jpeg");
    },
    licenseDefaultSize({ imageSize, visibleArea }) {
      let width = (visibleArea || imageSize).width;
      let height = (visibleArea || imageSize).height;
      let isCropped = this.captures.license.isCropped;
      if (!isCropped) {
        return {
          width: width - 80,
          height: height - 40,
        };
      }
      return {
        width,
        height,
      };
    },
    aadharDefaultSize({ imageSize, visibleArea }) {
      let width = (visibleArea || imageSize).width;
      let height = (visibleArea || imageSize).height;
      let isCropped = this.captures.aadhar.isCropped;
      if (!isCropped) {
        return {
          width: width - 80,
          height: height - 40,
        };
      }
      return {
        width,
        height,
      };
    },
    storeFile(file, id, index = "") {
      if (index !== "") {
        this.captures[id][`file${index}`] = file;
      } else {
        this.captures[id].file = file;
      }
    },
    async capturePhoto(id2, index = "") {
      let id = id2 + index;
      let canvas = document.querySelector(`#${id}-canvas`);
      let video = document.querySelector(`#${id}-video`);
      canvas.style.display = "block";
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      this.PlaySound(`${id}-sound`);
      // this.img = canvas.toDataURL('image/jpeg');
      let stream = video.srcObject;
      let tracks = stream.getVideoTracks();
      if (this.torch && tracks.length) {
        const videoTrack = tracks[0];
        await videoTrack.applyConstraints({ torch: false });
      }
      // data url of the image
      video.srcObject = null;
      document.querySelector(`#${id}-canvas`).toBlob((blob) => {
        this.storeFile(
          new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }),
          id2,
          index
        );
      }, "image/jpeg");
      if (this.captures[id2].stream) {
        this.captures[id2].stream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      video.style.display = "none";
    },
    async captureDocumentPhoto(id2, index = "") {
      let id = id2 + index;
      let video = document.querySelector(`#${id}-video`);
      const canvas2 = document.createElement("canvas");
      canvas2.width = video.videoWidth;
      canvas2.height = video.videoHeight;
      canvas2
        .getContext("2d")
        .drawImage(video, 0, 0, canvas2.width, canvas2.height);
      this.captures[id2].img = canvas2.toDataURL("image/jpeg");
      this.captures[id2].showCropper = true;
      this.captures[id2].isCropped = false;

      let stream = video.srcObject;
      let tracks = stream.getVideoTracks();
      if (this.torch && tracks.length) {
        const videoTrack = tracks[0];
        await videoTrack.applyConstraints({ torch: false });
      }
      video.srcObject = null;

      canvas2.toBlob((blob) => {
        this.storeFile(
          new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }),
          id2,
          index
        );
      }, "image/jpeg");
      if (this.captures[id2].stream) {
        this.captures[id2].stream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      video.style.display = "none";
    },
    handleSealOptionChange() {
      if (this.is_seal_optional) {
        this.captures.seal.file0 = null;
        this.captures.seal.file1 = null;
        this.captures.seal.file2 = null;
        this.captures.seal.file3 = null;
        this.captures.seal.seal_number_0 = null;
        this.captures.seal.seal_number_1 = null;
        this.captures.seal.seal_number_2 = null;
        this.captures.seal.seal_number_3 = null;
        this.sealNumberCount = 1;
      }
    },
    PlaySound(soundObjId) {
      var sound = document.getElementById(soundObjId);
      sound.play();
    },
    handleVehicleChange(id) {
      this.formData.route_number = null;
      if (id) {
        // let selectedVehicle = this.vehicleNumberList.find(v => v.id == id && ['BOOKING', 'DELIVERY'].includes(v.field))
        // if(selectedVehicle) {
        //     this.is_seal_optional = true
        // } else {
        //     this.is_seal_optional = false
        // }
        this.routeNumerList = this.vehiclesRouteNumerList.filter(
          (v) => v.vehicle_id == id
        );
      } else {
        // this.is_seal_optional = false
        this.routeNumerList = [];
      }
    },
    resetform() {
      this.formData.gate_number = null;
      this.formData.vehicle_number = null;
      this.formData.aadhar_number = null;
      this.formData.driving_license = null;
      this.formData.receiver_details = null;
      this.formData.ocr_vehicle_number = null;
      this.formData.route_number = null;
      this.formData.routeNumerList = [];
      this.captures.plate.file = null;
      this.captures.seal.file0 = null;
      this.captures.seal.file1 = null;
      this.captures.seal.file2 = null;
      this.captures.seal.file3 = null;
      this.captures.seal.seal_number_0 = null;
      this.captures.seal.seal_number_1 = null;
      this.captures.seal.seal_number_2 = null;
      this.captures.seal.seal_number_3 = null;
      this.captures.vehicle.file = null;
      this.formData.vehicle_number2 = null;
      let canvases = document.getElementsByClassName("c");
      for (let element of canvases) {
        element.style.display = "none";
      }
      if (!this.is_seal_optional) {
        for (let i = 0; i < this.sealNumberCount; i++) {
          this.clearPhoto(`seal${i}-canvas`);
        }
      }

      for (let type of this.fileTitle.filter(
        (i) => !this.cropAllowed.includes(i)
      )) {
        this.clearPhoto(`${type}-canvas`);
        this.captures[type].stream = null;
        this.captures[type].file = null;
      }
      for (let type of this.cropAllowed) {
        this.captures[type].img = null;
        this.captures[type].stream = null;
        this.captures[type].isCropped = false;
        this.captures[type].showCropper = false;
      }
      this.sealNumberCount = 1;
    },
    resetGateExitform() {
      this.formData_gate_exit.gate_number = null;
      this.formData_gate_exit.vehicle_number = null;
      this.captures_gate_exit.seal.file0 = null;
      this.captures_gate_exit.seal.file1 = null;
      this.captures_gate_exit.seal.file2 = null;
      this.captures_gate_exit.seal.file3 = null;
      this.captures_gate_exit.seal.seal_number_0 = null;
      this.captures_gate_exit.seal.seal_number_1 = null;
      this.captures_gate_exit.seal.seal_number_2 = null;
      this.captures_gate_exit.seal.seal_number_3 = null;
      this.sealExitNumberCount = 0;
    },
    validateForm() {
      let isValid = true;
      if (!this.formData.gate_number) {
        isValid = false;
      }
      if (this.formData.is_marketing_vehicle) {
        this.formData.route_number = null;
      }
      if (
        !this.formData.is_marketing_vehicle &&
        !this.formData.vehicle_number
      ) {
        return false;
      }
      if (
        this.formData.is_marketing_vehicle &&
        !this.getTrimmedString(this.formData.vehicle_number2)
      ) {
        return false;
      }
      for (let title of this.fileTitle) {
        if (title !== "aadhar") {
          let file = this.captures[title].file;
          if (!file) {
            isValid = false;
          }
        }
      }
      if (!this.is_seal_optional) {
        for (let i = 0; i < this.sealNumberCount; i++) {
          let sealValue = this.captures.seal[`seal_number_${i}`];
          let fileValue = this.captures.seal[`file${i}`];
          if (!sealValue || !fileValue) {
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateGateExitForm() {
      let isValid = true;
      if (
        !this.formData_gate_exit.gate_number ||
        !this.formData_gate_exit.vehicle_number
      ) {
        isValid = false;
      }
      for (let i = 0; i < this.sealExitNumberCount; i++) {
        let sealValue = this.captures_gate_exit.seal[`seal_number_${i}`];
        let fileValue = this.captures_gate_exit.seal[`file${i}`];
        if (!sealValue || !fileValue) {
          isValid = false;
        }
      }
      if (this.gate_entry_pass_photos.length < 2) {
        isValid = false;
      }
      return isValid;
    },
    getEntryGateList() {
      this.makeRequest("GET", "/master/gates/entry-gates")
        .then((result) => {
          this.gateNumberList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getExitGateList() {
      this.makeRequest("GET", "/master/gates/exit-gates")
        .then((result) => {
          this.exitGateList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getVehicleNumberList() {
      this.searchNameMasterList(
        "vehicle_registration_master",
        "vehicle_number_plate",
        null,
        "vehicle_id",
        "vehicle_transaction_type"
      )
        .then((result) => {
          this.vehicleNumberList = result.data;
          this.getRouteNumbers();
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getRouteNumbers() {
      this.makeRequest(
        "post",
        "/routes/route-vehicle-controlling/get-routes-by-vehicle",
        this.vehicleNumberList.map((i) => i.id)
      )
        .then((result) => {
          this.vehiclesRouteNumerList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getGateExitVehicles() {
      let url = "/exit/gate-control/gate-exit-vehicles";
      this.makeRequest("GET", url)
        .then((result) => {
          this.exitVehicleNumberList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getVehicleEntryPass(id) {
      if (id) {
        this.isLoading = true;
        let url = `/entry/gate-control/${id}/gate-entry-pass`;
        this.makeRequest("GET", url)
          .then((result) => {
            this.isLoading = false;
            if (result?.data?.status) {
              this.gate_entry_pass_photos = result.data.presingUrls;
            } else {
              let message =
                "Failed to fetch vehicle entry pass. Please retry after few seconds!";
              if (result?.data?.message) {
                message = result?.data?.message;
              }
              this.gate_entry_pass_photos = [];
              this.sweetAlertSnackbar(message, "error");
            }
          })
          .catch((e) => {
            this.gate_entry_pass_photos = [];
            this.displayError(e);
          });
        let currVehicle = this.exitVehicleNumberList.find(
          (vehicle) => vehicle.id == id
        );
        if (currVehicle) {
          this.sealExitNumberCount = currVehicle.seal_scan_no.length;
          for (let i = 0; i < this.sealExitNumberCount; i++) {
            this.captures_gate_exit.seal[`seal_number_${i}`] =
              currVehicle.seal_scan_no[i];
          }
        } else {
          this.sealExitNumberCount = 0;
        }
      } else {
        this.gate_entry_pass_photos = [];
        this.sealExitNumberCount = 0;
      }
    },
    async saveData() {
      if (!this.validateForm()) {
        this.sweetAlertSnackbar(
          "Form was invalidated. Make sure that all reuired fields are filled out!",
          "error"
        );
        return;
      }
      this.isLoading = true;
      if (this.formData.is_marketing_vehicle) {
        this.formData.route_number = null;
        let payload = {
          vehicle_number_plate: this.formData.vehicle_number2,
        };
        let isReqSuccess = false;
        let message = "Error adding market vehicle";
        try {
          let vendorCreateRes = await this.makeRequest(
            "POST",
            "/master/createMarketVehicle",
            { vehicle_number_plate: this.formData.vehicle_number2 }
          );
          if (vendorCreateRes?.data?.status) {
            this.formData.vehicle_number =
              vendorCreateRes.data?.data.vehicle_id;
            isReqSuccess = true;
          } else {
            message = vendorCreateRes?.data?.message ?? message;
          }
        } catch (e) {
          this.displayError(e);
          message = e?.response?.data?.message ?? message;
        }
        if (!isReqSuccess) {
          this.sweetAlertSnackbar(message, "error");
          return;
        }
      }
      let dataVerficationApiUrl = `/entry/gate-control/${this.formData.vehicle_number}/gate-entry-verify`;
      this.makeRequest("GET", dataVerficationApiUrl)
        .then((result) => {
          if (result.data.status) {
            var formData = new FormData();
            for (let fileTitle of this.fileTitle) {
              if (this.captures[fileTitle].file) {
                formData.append("files", this.captures[fileTitle].file);
              }
            }
            if (!this.is_seal_optional) {
              for (let i = 0; i < this.sealNumberCount; i++) {
                let fileValue = this.captures.seal[`file${i}`];
                fileValue[`seal_number_${i}`] =
                  this.captures.seal[`seal_number_${i}`];
                formData.append("files", fileValue);
              }
            }

            formData.append("folder", "gate_entry");
            let url = "/files/s3/bulkUploadFiles";
            axios({
              "content-type": "multipart/form-data",
              method: "POST",
              url: url,
              data: formData,
            })
              .then((result) => {
                if (result.data.status) {
                  let files = result.data.data;
                  let payload = this.formData;
                  payload.seal_details = [];
                  for (let file of files) {
                    let fileName = file.fileName.split(".")[0];
                    if (fileName.includes("seal") && !this.is_seal_optional) {
                      let sealNumber = fileName.split("_")[0].slice(-1);
                      payload.seal_details.push({
                        seal_number:
                          this.captures.seal[`seal_number_${sealNumber}`],
                        seal_photo: file.fileKey,
                      });
                    } else {
                      payload[fileName] = file.fileKey;
                    }
                  }
                  let method = "POST";
                  let url = "/master/gates/gate-entry/create";
                  axios({
                    method,
                    url,
                    data: payload,
                  })
                    .then((result) => {
                      this.isLoading = false;
                      this.resetform();
                      if (result && result.data && result.data.status) {
                        this.sweetAlertSnackbar(result.data.message, "success");
                      } else {
                        this.sweetAlertSnackbar(result.data.message, "error");
                      }
                    })
                    .catch((e) => {
                      this.displayError(e);
                    });
                  // this.sweetAlertSnackbar(result.data.message, 'success', 'top')
                } else {
                  this.sweetAlertSnackbar(result.data.message, "error");
                }
              })
              .catch((e) => {
                this.displayError(e);
              });
          } else {
            this.sweetAlertSnackbar(
              "Gate entry scan already done for this vehicle",
              "error"
            );
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    saveExitGateData() {
      if (!this.validateGateExitForm()) {
        this.sweetAlertSnackbar(
          "Form was invalidated. Make sure that all reuired fields are filled out!",
          "error"
        );
        return;
      }
      this.isLoading = true;
      let dataVerficationApiUrl = `/entry/gate-control/${this.formData_gate_exit.vehicle_number}/gate-exit-verify`;
      this.makeRequest("GET", dataVerficationApiUrl)
        .then((result) => {
          if (result.data.status) {
            var formData = new FormData();
            for (let i = 0; i < this.sealExitNumberCount; i++) {
              let fileValue = this.captures_gate_exit.seal[`file${i}`];
              fileValue[`seal_number_${i}`] =
                this.captures_gate_exit.seal[`seal_number_${i}`];
              formData.append("files", fileValue);
            }
            formData.append("folder", "gate_exit");
            let url = "/files/s3/bulkUploadFiles";
            axios({
              "content-type": "multipart/form-data",
              method: "POST",
              url: url,
              data: formData,
            })
              .then((result) => {
                if (result.data.status) {
                  let files = result.data.data;
                  let payload = this.formData_gate_exit;
                  payload.seal_details = [];
                  for (let file of files) {
                    let fileName = file.fileName.split(".")[0];
                    if (!fileName.includes("seal")) {
                      // payload[fileName] = file.fileKey
                    } else {
                      let sealNumber = fileName.split("_")[0].slice(-1);
                      payload.seal_details.push({
                        seal_number:
                          this.captures_gate_exit.seal[
                            `seal_number_${sealNumber}`
                          ],
                        seal_photo: file.fileKey,
                      });
                    }
                  }
                  let method = "POST";
                  let url = "/master/gates/gate-exit/create";
                  axios({
                    method,
                    url,
                    data: payload,
                  })
                    .then((result) => {
                      this.isLoading = false;
                      this.resetGateExitform();
                      this.getGateExitVehicles();
                      if (result && result.data && result.data.status) {
                        this.sweetAlertSnackbar(result.data.message, "success");
                      } else {
                        this.sweetAlertSnackbar(result.data.message, "error");
                      }
                    })
                    .catch((e) => {
                      this.displayError(e);
                    });
                  // this.sweetAlertSnackbar(result.data.message, 'success', 'top')
                } else {
                  this.sweetAlertSnackbar(result.data.message, "error");
                }
              })
              .catch((e) => {
                this.displayError(e);
              });
          } else {
            let message = `Gate entry scan already done for this vehicle`;
            if (result?.data?.message) {
              message = result.data.message;
            }
            this.sweetAlertSnackbar(message, "error");
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    selectstatus() {},
    async startStream(constraints) {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      return stream;
    },
    async turnOnCamera(id2, index = "") {
      this.isLoading = true;
      // Capture logic here
      let id = id2 + index;
      let video = document.getElementById(`${id}-video`);
      video.style.display = "block";
      let isCroppingAllowed = this.cropAllowed.includes(id2);

      let videoConstraints = {
        audio: false,
        video: {
          width: { ideal: isCroppingAllowed ? 2160 : 4096 },
          height: { ideal: isCroppingAllowed ? 4096 : 2160 },
          facingMode: {
            exact: "environment",
          },
        },
      };
      if (this.camera) {
        videoConstraints = { video: { facingMode: "user" }, audio: false };
      }
      try {
        let stream = await navigator.mediaDevices.getUserMedia(
          videoConstraints
        );
        let tracks = stream.getVideoTracks();
        if (this.torch) {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: true });
          }
        } else {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: false });
          }
        }
        this.captures[id2].stream = stream;
        video.srcObject = stream;
      } catch (e) {
        video.style.display = "none";
        this.displayError(e);
      }
      this.isLoading = false;
    },
    async turnOnCamera2(id2, index = "") {
      document.getElementById("overlay-camera").style.display = "block";
      this.isLoading = true;
      let id = id2 + index;
      let videoConstraints = { video: { facingMode: "user" }, audio: false };
      try {
        let stream = await navigator.mediaDevices.getUserMedia(
          videoConstraints
        );
        this.captures["v"].stream = stream;
        let video = document.querySelector(`#overlay-camera`);
        video.srcObject = stream;
      } catch (e) {
        this.displayError(e);
      }
      this.isLoading = false;
    },
    async clickPicture(id2, index = "") {
      let id = id2 + index;
      let canvas = document.querySelector(`#c`);
      canvas.style.display = "block";
      let video = document.querySelector(`#overlay-camera`);
      // var cw = Math.floor(canvas.clientWidth / 100);
      // var ch = Math.floor(canvas.clientHeight / 100);
      // canvas.width = cw;
      // canvas.height = ch;
      this.PlaySound("sound1");
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      let image_data_url = canvas.toDataURL("image/jpeg");

      // data url of the image
      let stream = video.srcObject;
      let tracks = stream.getVideoTracks();
      if (this.torch && tracks.length) {
        const videoTrack = tracks[0];
        await videoTrack.applyConstraints({ torch: false });
      }
      video.srcObject = null;
      const storeFile = (file) => {
        if (index !== "") {
          this.captures["v"][`file${index}`] = file;
        } else {
          this.captures[id2].file = file;
        }
      };
      document.querySelector(`#c`).toBlob((blob) => {
        storeFile(
          new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }),
          id2,
          index
        );
      }, "image/jpeg");
      if (this.captures[id2].stream) {
        this.captures[id2].stream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      document.getElementById("overlay-camera").style.display = "none";
    },
    handleCameraSelection(id) {
      this.camera = id;
    },
    async getCameraSelection() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );
      const options = videoDevices.map((videoDevice) => {
        return {
          id: videoDevice.deviceId,
          label: videoDevice.label,
        };
      });
      this.camera_options = options;
    },
    scaleIt(source, scaleFactor) {
      var c = document.createElement("canvas");
      var ctx = c.getContext("2d");
      var w = source.width * scaleFactor;
      var h = source.height * scaleFactor;
      c.width = w;
      c.height = h;
      ctx.drawImage(source, 0, 0, w, h);
      return c;
    },
    async turnOnExitScanCamera(id2, index = "") {
      this.isLoading = true;
      let id = id2 + index;
      let videoConstraints = {
        audio: false,
        video: {
          facingMode: {
            exact: "environment",
          },
        },
      };
      let video = document.querySelector(`#${id}-gate_exit_video`);
      video.style.display = "block";
      if (this.camera) {
        videoConstraints = { video: { facingMode: "user" }, audio: false };
      }

      try {
        let stream = await navigator.mediaDevices.getUserMedia(
          videoConstraints
        );
        let tracks = stream.getVideoTracks();
        if (this.torch) {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: true });
          }
        } else {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: false });
          }
        }
        this.captures_gate_exit[id2].stream = stream;
        video.srcObject = stream;
      } catch (e) {
        video.style.display = "none";
        this.displayError(e);
      }
      this.isLoading = false;
    },
    async captureGateExitPhoto(id2, index = "") {
      let id = id2 + index;
      let canvas = document.querySelector(`#${id}-gate_exit_canvas`);
      let video = document.querySelector(`#${id}-gate_exit_video`);
      canvas.style.display = "block";
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      // let image_data_url = canvas.toDataURL('image/jpeg');
      this.PlaySound(`${id}-gate_exit_sound`);
      let stream = video.srcObject;
      let tracks = stream.getVideoTracks();
      if (this.torch && tracks.length) {
        const videoTrack = tracks[0];
        await videoTrack.applyConstraints({ torch: false });
      }
      // data url of the image
      video.srcObject = null;
      const storeFile = (file) => {
        if (index !== "") {
          this.captures_gate_exit[id2][`file${index}`] = file;
        } else {
          this.captures_gate_exit[id2].file = file;
        }
      };
      document.querySelector(`#${id}-gate_exit_canvas`).toBlob(function (blob) {
        storeFile(
          new File([blob], `${id}_gate_exit_photo.jpg`, { type: "image/jpeg" })
        );
      }, "image/jpeg");
      if (this.captures_gate_exit[id2].stream) {
        this.captures_gate_exit[id2].stream
          .getTracks()
          .forEach(function (track) {
            track.stop();
          });
      }
      video.style.display = "none";
    },
    clearPhoto(id) {
      let canvas = document.querySelector(`#${id}`);
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    },
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}

#v {
  position: absolute;
  top: 0%;
  left: 0%;
  margin: auto;
}

#c {
  display: none;
}
.c {
  display: none;
  object-fit: cover;
}

#overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}
.cropper {
  width: 100%;
  height: auto;
  background: #ddd;
}

.contains {
  margin: auto;
  position: relative;
}
</style>
